import React, { useState, useEffect } from "react";
import { CardElement, ElementsConsumer, Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import axios from "axios";
import API from "../../API";
import Cookies from 'js-cookie';
import LoaderModal from "../../components/loaders/LoaderModal";
import { TailSpin } from 'react-loader-spinner';
import { Container, Row, Col } from 'reactstrap';
import { useHistory } from 'react-router-dom';
import AddCards from './payment-form';

const stripePromise = loadStripe(API.stripeId);

// Icons
import walletIcon from "../../assets/svgs/Wallet.svg";
import documentIcon from "../../assets/svgs/payment-info.svg";
import amountIcon from "../../assets/svgs/Amount.svg";
import amountSelectedIcon from "../../assets/svgs/amount-selected.svg";
import lockIcon from "../../assets/svgs/Lock.svg";

const AddFunds = () => {
  const [loadingShow, setLoadingShow] = useState(false);
  const [cardsLoader, setCardsLoader] = useState(false);
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [paymentError, setPaymentError] = useState("");
  const [error, setError] = useState("");
  const [addNewCard, setAddNewCard] = useState(false);
  const [availableCards, setAvailableCards] = useState([]);
  const [selectedCardId, setSelectedCardId] = useState("");
  const [amount, setAmount] = useState("");
  const [availableAmounts, setAvailableAmounts] = useState([]);
  const [amountId, setAmountId] = useState(null);
  const [cardHolderName, setCardHolderName] = useState("");
  const [showAddCard, setShowAddCard] = useState(false);
  const history = useHistory();
  const fetchAvailableCards = async () => {
    try {
      setCardsLoader(true);
      const response = await axios.get(
        `${API.baseURL}/providers/wallet_get_provider_card_details`,
        API.options
      );
      if (response.data.code === 200) {
        setAvailableCards(response.data.data.stripe_card_details || []);
      } else {
        setError(response.data.message);
      }
    } catch (err) {
      console.error("API Error:", err);
      setError("Failed to fetch card details");
    } finally {
      setShowAddCard(false);
      setCardsLoader(false);
    }
  };
  const renderAddCardForm = () => <AddCards onSuccess={fetchAvailableCards} showAddCard={showAddCard} setShowAddCard={setShowAddCard}/>;
  useEffect(() => {
    fetchAvailableCards();
    fetchAvailableAmounts();
  }, []);


  const fetchAvailableAmounts = async () => {
    try {
      const response = await axios.get(
        `${API.baseURL}/v2/providers/wallet_plans`,
        API.options
      );
      if (response.status === 200) {
        setAvailableAmounts(response?.data);
      } else {
        setError(response.data.message);
      }
    } catch (err) {
      console.error("API Error:", err);
      setError("Failed to fetch available amounts");
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!amount || !selectedCardId) {
      setError("Please select an amount and card");
      return;
    }
    setError("");
    setPaymentError("");
    setLoadingShow(true);
    
    const data = {
      user_id: Cookies.get('provider_id'),
      plan_id: amountId,
      payment_method: selectedCardId,
    };

    try {
      const response = await axios.post(API.baseURL + `/v2/providers/add_amount_to_wallet`, data, API.options);
      if (response.data) {
        setPaymentSuccess(true);
        setLoadingShow(false);
      } else {
        setPaymentError(response?.data?.message || "Payment confirmation failed");
        setLoadingShow(false);
      }
    } catch (error) {
      console.log("Error:", error);
      setPaymentError(
        error?.response?.data?.error ||
          error?.response?.data?.message ||
          "Payment confirmation failed"
      );
      setLoadingShow(false);
    }
  };

  const CARD_ELEMENT_OPTIONS = {
    style: {
      base: {
        color: "#32325d",
        fontSize: "16px",
        "::placeholder": {
          color: "#aab7c4",
        },
      },
      invalid: {
        color: "#fa755a",
        iconColor: "#fa755a",
      },
    },
  };

  const handleContinueWithoutFunding = () => {
    history.push('/wallet-history');
  };

  return (
    <Elements stripe={stripePromise}>
      <ElementsConsumer>
        {({ stripe, elements }) => (
          <div style={{ 
            backgroundColor: '#F5F5F5', 
            minHeight: '100vh',
            padding: '40px 20px',
            marginTop: '80px'
          }}>
            <Container>
              <Row className="d-flex justify-content-center align-items-center">
                <Col sm="12" md="10" lg="8">
                  {/* Stepper placeholder */}

                    <Row>
                      {/* Left Column - Fund Your Wallet Card */}
                      <Col sm="6">
                        <div style={{
                          border: '1px solid #3D84FB',
                          borderRadius: '16px',
                          padding: '40px 30px',
                          backgroundColor: '#fff',
                          height: '78vh',
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'center',
                          textAlign: 'center',
                          boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
                        }}>
                          <div style={{
                            width: '80px',
                            height: '80px',
                            backgroundColor: '#F0F8FF',
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginBottom: '25px'
                          }}>
                            <img src={walletIcon} alt="Wallet" width="40" height="40" />
                          </div>
                          <h3 style={{
                            fontSize: '28px',
                            fontWeight: 'bold',
                            color: '#171717',
                            marginBottom: '15px'
                          }}>
                            Fund Your Wallet
                          </h3>
                          <p style={{
                            fontSize: '16px',
                            color: '#666',
                            lineHeight: '1.6'
                          }}>
                            Top up your wallet for immediate use after signup
                          </p>
                        </div>
                      </Col>

                      {/* Right Column - Two Separate Cards */}
                      <Col sm="6">
                        <div style={{ height: '100%', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                          {/* Amount Selection Card */}
                          <div style={{
                            backgroundColor: '#fff',
                            borderRadius: '16px',
                            padding: '25px',
                            paddingBottom: '0px',
                            boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                            height: 'fit-content'
                          }}>
                            {/* <h4 style={{
                              fontSize: '20px',
                              fontWeight: 'bold',
                              color: '#171717',
                              marginBottom: '20px',
                              display: 'flex',
                              alignItems: 'center'
                            }}>
                              <img src={amountIcon} alt="Amount" width="22" height="22" style={{ marginRight: '10px' }} />
                              Select Amount
                            </h4> */}
                            <div style={{ 
                              display: 'flex', 
                              flexDirection: 'row', 
                              flexWrap: 'wrap',
                              gap: '6px', 
                              marginBottom: '15px',
                              justifyContent: 'center',
                              alignItems: 'center',
                              // minWidth: 'calc(3 * 116px + 2 * 6px)'
                            }}>
                              {availableAmounts?.map((amt) => (
                                <button
                                  key={amt.id}
                                  style={{
                                    padding: '5px 12px',
                                    border: amount === amt?.amount ? '2px solid #21A145' : '1px solid #E5E5E5',
                                    background: amount === amt?.amount ? '#F0FFF0' : '#fff',
                                    color: amount === amt?.amount ? '#21A145' : '#171717',
                                    borderRadius: '100px',
                                    width: '100px',
                                    height: '55px',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '16px',
                                    fontWeight: '500',
                                    transition: 'all 0.2s ease'
                                  }}
                                  onClick={() => {
                                    setAmount(amt.amount);
                                    setAmountId(amt.id);
                                  }}
                                >
                                  <img 
                                    src={amount === amt?.amount ? amountSelectedIcon : amountIcon} 
                                    alt="Amount" 
                                    width="18" 
                                    height="18" 
                                    style={{ 
                                      marginBottom: '6px'
                                    }} 
                                  />
                                  ${amt.amount}
                                </button>
                              ))}
                            </div>
                            {/* Custom Amount Input Field */}
                            {/* <div style={{
                              backgroundColor: '#F5F5F5',
                              borderRadius: '10px',
                              padding: '12px',
                              border: '1px solid #E5E5E5'
                            }}>
                              <input
                                type="text"
                                placeholder="Enter Custom Amount"
                                style={{
                                  width: '100%',
                                  border: 'none',
                                  background: 'transparent',
                                  fontSize: '14px',
                                  color: '#666',
                                  outline: 'none'
                                }}
                                disabled
                              />
                            </div> */}
                          </div>

                          {/* Payment Info Card */}
                          <div style={{
                            backgroundColor: '#fff',
                            borderRadius: '16px',
                            padding: '15px',
                            boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                            flex: 1
                          }}>
                            <h4 style={{
                              fontSize: '20px',
                              fontWeight: 'bold',
                              color: '#171717',
                              marginBottom: '15px',
                              display: 'flex',
                              alignItems: 'center'
                            }}>
                              <img src={documentIcon} alt="Payment" width="22" height="22" style={{ marginRight: '10px' }} />
                              Payment
                            </h4>
                            <p style={{
                              fontSize: '16px',
                              color: '#666',
                              marginBottom: '10px'
                            }}>
                              {availableCards.length > 0 ? 'Select your payment method' : 'Add your card details'}
                            </p>

                            {cardsLoader ? (
                              <div style={{ display: 'flex', justifyContent: 'center', padding: '30px' }}>
                                <TailSpin height="50" width="50" color="#3D84FB" />
                              </div>
                            ) : (
                              <div>
                                {availableCards.map((card) => (
                                  <div 
                                    key={card.id}
                                    onClick={() => {
                                      setSelectedCardId(card.id);
                                      setAddNewCard(false);
                                    }}
                                    style={{
                                      padding: '10px',
                                      border: selectedCardId === card.id ? '2px solid #3D84FB' : '1px solid #E5E5E5',
                                      borderRadius: '10px',
                                      backgroundColor: selectedCardId === card.id ? '#F0F8FF' : '#fff',
                                      cursor: 'pointer',
                                      marginBottom: '15px',
                                      display: 'flex',
                                      alignItems: 'center',
                                      transition: 'all 0.2s ease'
                                    }}
                                  >
                                    <img
                                      src={card.card_icon}
                                      alt="Card"
                                      style={{ width: '50px', height: '32px', marginRight: '20px' }}
                                    />
                                    <div style={{ flex: 1 }}>
                                      <div style={{ fontSize: '16px', fontWeight: '500', marginBottom: '6px' }}>
                                      •••• •••• •••• {card.last4_digit}
                                      </div>
                                      <div style={{ fontSize: '14px', color: '#666' }}>
                                      {`Expires: ${card.exp_month < 10 ? '0' + card.exp_month : card.exp_month}/${String(card.exp_year).slice(-2)}`}
                                      </div>
                                    </div>
                                  </div>
                                ))}
                                <button
                                  onClick={() => { event.preventDefault();setShowAddCard(true);}} // Add relevant handler
                                  style={{
                                    marginTop: '20px',
                                    padding: '10px 15px',
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                    backgroundColor: '#3478F6',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '8px',
                                    cursor: 'pointer',
                                    width: '100%',
                                    textAlign: 'center',
                                  }}
                                >
                                  + Add Card
                                </button>
                                {showAddCard && renderAddCardForm()}
                                {addNewCard && (
                                  <div style={{ marginTop: '25px' }}>
                                    <CardElement options={CARD_ELEMENT_OPTIONS} />
                                  </div>
                                )}

                                <div style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  marginTop: '25px',
                                  fontSize: '16px',
                                  color: '#666'
                                }}>
                                  <img src={lockIcon} alt="Lock" width="16" height="16" style={{ marginRight: '10px' }} />
                                  Your payment info is stored securely
                                </div>
                              </div>
                            )}

                          </div>
                            {/* Action Buttons */}
                            <div>
                              <button
                                onClick={handleSubmit}
                                disabled={!amount || !selectedCardId || loadingShow}
                                style={{
                                  width: '100%',
                                  padding: '15px',
                                  backgroundColor: (!amount || !selectedCardId) ? '#E5E5E5' : '#3D84FB',
                                  color: (!amount || !selectedCardId) ? '#999' : '#fff',
                                  border: 'none',
                                  borderRadius: '12px',
                                  fontSize: '20px',
                                  fontWeight: '500',
                                  cursor: (!amount || !selectedCardId) ? 'not-allowed' : 'pointer',
                                  marginBottom: '20px',
                                  transition: 'all 0.2s ease'
                                }}
                              >
                                CONTINUE
                              </button>

                              <button
                                onClick={handleContinueWithoutFunding}
                                style={{
                                  width: '100%',
                                //   padding: '5px',
                                  backgroundColor: 'transparent',
                                  color: '#666',
                                  border: 'none',
                                  fontSize: '18px',
                                  cursor: 'pointer',
                                  textDecoration: 'underline'
                                }}
                              >
                                Continue without funding
                              </button>
                            </div>
                        </div>
                      </Col>
                    </Row>
                </Col>
              </Row>
            </Container>

            {/* Error Message */}
            {error && (
              <div style={{
                position: 'fixed',
                top: '20px',
                right: '20px',
                backgroundColor: '#ff6b6b',
                color: '#fff',
                padding: '15px 20px',
                borderRadius: '8px',
                zIndex: 1000
              }}>
                {error}
              </div>
            )}

            {/* Loader Modal */}
            <LoaderModal 
              loadingShow={loadingShow} 
              message={'Processing payment...'} 
              closeModal={() => {
                setLoadingShow(false);
                if (paymentSuccess) {
                  history.push('/wallet-history');
                }
              }} 
            />

            {/* Success Modal */}
            {paymentSuccess && (
              <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 1000
              }}>
                <div style={{
                  backgroundColor: '#fff',
                  padding: '40px',
                  borderRadius: '12px',
                  textAlign: 'center',
                  maxWidth: '400px',
                  width: '90%'
                }}>
                  <div style={{ marginBottom: '20px' }}>
                    <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect width="52" height="52" rx="26" fill="#21A145" fillOpacity="0.1" />
                      <path d="M35.3334 19L22.5 31.8333L16.6667 26" stroke="#21A145" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </div>
                  <h2 style={{ color: "#333", fontWeight: 'bold', fontSize: "18px", marginBottom: "10px" }}>
                    Payment Successful!
                  </h2>
                  <p style={{ fontSize: "14px", color: "#545458", marginBottom: "20px" }}>
                    Amount successfully added to your wallet.
                  </p>
                  <button
                    onClick={() => {
                      setPaymentSuccess(false);
                      history.push('/wallet-history');
                    }}
                    style={{
                      width: "100%",
                      padding: "12px",
                      backgroundColor: "#3D84FB",
                      color: "white",
                      border: "none",
                      borderRadius: "8px",
                      cursor: "pointer",
                      fontSize: "16px",
                      fontWeight: "500"
                    }}
                  >
                    DONE
                  </button>
                </div>
              </div>
            )}

            {/* Payment Error Modal */}
            {paymentError && (
              <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 1000
              }}>
                <div style={{
                  backgroundColor: '#fff',
                  padding: '40px',
                  borderRadius: '12px',
                  textAlign: 'center',
                  maxWidth: '400px',
                  width: '90%'
                }}>
                  <div style={{ marginBottom: '20px' }}>
                    <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect width="52" height="52" rx="26" fill="#E53935" fillOpacity="0.1" />
                      <path d="M18 18L34 34M34 18L18 34" stroke="#E53935" strokeWidth="2.5" strokeLinecap="round" />
                    </svg>
                  </div>
                  <h2 style={{ color: "#333", fontWeight: 'bold', fontSize: "18px", marginBottom: "10px" }}>
                    Payment Failed
                  </h2>
                  <p style={{ fontSize: "14px", color: "#545458", marginBottom: "20px" }}>
                    {paymentError}
                  </p>
                  <button
                    onClick={() => {
                      setPaymentError("");
                    }}
                    style={{
                      width: "100%",
                      padding: "12px",
                      backgroundColor: "#E53935",
                      color: "white",
                      border: "none",
                      borderRadius: "8px",
                      cursor: "pointer",
                      fontSize: "16px",
                      fontWeight: "500"
                    }}
                  >
                    OK
                  </button>
                </div>
              </div>
            )}
          </div>
        )}
      </ElementsConsumer>
    </Elements>
  );
};

export default AddFunds; 
